export * from "./ArrowLeft"
export * from "./ArrowMenu"
export * from "./ArrowRight"
export * from "./ArrowSidemenu"
export * from "./Discord"
export * from "./Facebook"
export * from "./FacebookMessenger"
export * from "./Favorites"
export * from "./Home"
export * from "./Instagram"
export * from "./Linkedin"
export * from "./Mail"
export * from "./Marker"
export * from "./Search"
export * from "./Telegram"
export * from "./Twitch"
export * from "./Twitter"
export * from "./Whatsapp"
export * from "./filePdf"
export * from "./fileDoc"
